export default __webpack_public_path__ + "media/images/service_skirent-da2c9a9f9cddb7ce49b343be715bd81f.jpg";